module.exports = __webpack_public_path__ + "static/media/rocket-ship.5bd34f9a.png";